import { Injectable } from '@angular/core';
import { EquipmentAttribute } from 'src/app/core/models/equipment-attribute.model';
import { EquipmentCategory } from 'src/app/core/models/equipment-category.model';
import { LocalStorageService } from 'src/app/core/storage/local-storage/local-storage.service';

@Injectable({
	providedIn: 'root'
})
export class EquipmentService {

	constructor(
		private storage: LocalStorageService,
	) { }

	async getAttributes(): Promise<EquipmentAttribute[]> {
		return (await this.storage.equipmentAttributes.getAll())
			?.sort((a, b) => a.attribute > b.attribute ? 1 : -1);
	}

	async getAttributeById(id: number): Promise<EquipmentAttribute> {
		return await this.storage.equipmentAttributes.getItem(id);
	}

	async getCategories(): Promise<EquipmentCategory[]> {
		return (await this.storage.equipmentCategories.getAll())
			?.sort((a, b) => a.name > b.name ? 1 : -1);
	}
}
